<template>
  <div class="pattern-wrap">
    <div :style="{ background: baseColor.backgroundColor }" class="base-color" id="base-color">
    </div>
    <div :style="{ background: finishColor.backgroundColor }"
         id="finish-color"
         class="finish-color">
    </div>
    <div :style="{ background: baseColor.backgroundColor }"
         class="base-color"
         @click="basePopoverOnOpen">
    </div>
    <div :style="{ background: secondaryColor.backgroundColor }"
         class="secondary-color"
         id="secondary"
    ></div>
    <div :style="{ background: baseColor.backgroundColor }"
         class="base-color"
         @click="basePopoverOnOpen">
    </div>
    <div class="finish-color"
         :style="{ background: finishColor.backgroundColor }"
         @click="finishPopoverOnOpen">
    </div>
    <div :style="{ background: baseColor.backgroundColor }"
         class="base-color"
         @click="basePopoverOnOpen">
    </div>
    <b-popover
      target="base-color"
      triggers="click blur"
      placement="left"
      ref="basePopover"
    >
      <ColorPicker
        v-on-clickaway="close"
        :colors="colorsCategories.trimColors"
        @onSelectColor="onSelectBaseColor"
      />
    </b-popover>
    <b-popover
      target="secondary"
      triggers="click blur"
      placement="left"
      ref="secondaryPopover"
    >
      <ColorPicker
        v-on-clickaway="close"
        :colors="colorsCategories.trimColors"
        @onSelectColor="onSelectSecondaryColor"
      />
    </b-popover>
    <b-popover
      target="finish-color"
      triggers="click blur"
      placement="left"
      ref="finishPopover"
    >
      <ColorPicker
        v-on-clickaway="close"
        :colors="colorsCategories.trimColors"
        @onSelectColor="onSelectFinishColor"
      />
    </b-popover>
  </div>
</template>

<script>
import ColorPicker from '@/components/common/ColorPicker.vue';
import { mixin as clickaway } from 'vue-clickaway';

export default {
  name: 'PatternD',
  components: {
    ColorPicker
  },
  mixins: [clickaway],
  data () {
    return {
      baseColor: {
        backgroundColor: null
      },
      secondaryColor: {
        backgroundColor: null
      },
      finishColor: {
        backgroundColor: null
      },
    };
  },
  mounted () {
    this.changeBaseColor();
    this.changeSecondaryColor();
    this.changeFinishColor();
  },
  computed: {
    baseTrimsColor () {
      return this.$store.getters['design/getBaseTrimsColor'];
    },
    secondaryTrimsColor () {
      return this.$store.getters['design/getSecondaryTrimsColor'];
    },
    finishTrimsColor () {
      return this.$store.getters['design/getFinishTrimsColor'];
    },
    colorsCategories () {
      return this.$store.getters['elements/getColorsCategories'];
    },
  },
  watch: {
    baseTrimsColor () {
      this.changeBaseColor();
    },
    secondaryTrimsColor () {
      this.changeSecondaryColor();
    },
    finishTrimsColor () {
      this.changeFinishColor();
    }
  },
  methods: {
    basePopoverOnOpen () {
      this.$refs.basePopover.$emit('open');
    },
    secondaryPopoverOnOpen () {
      this.$refs.secondaryPopover.$emit('open');
    },
    finishPopoverOnOpen () {
      this.$refs.finishPopover.$emit('open');
    },
    changeBaseColor () {
      this.baseColor.backgroundColor = this.baseTrimsColor.hex;
    },
    changeSecondaryColor () {
      this.secondaryColor.backgroundColor = this.secondaryTrimsColor.hex;
    },
    changeFinishColor () {
      this.finishColor.backgroundColor = this.finishTrimsColor.hex;
    },
    onSelectBaseColor (color) {
      this.$store.commit('design/setBaseTrimColor', { color });
      this.$refs.basePopover.$emit('close');
    },
    onSelectSecondaryColor (color) {
      this.$store.commit('design/setSecondaryTrimColor', { color });
      this.$refs.secondaryPopover.$emit('close');
    },
    onSelectFinishColor (color) {
      this.$store.commit('design/setFinishTrimColor', { color });
      this.$refs.finishPopover.$emit('close');
    },
    close () {
      this.$refs.basePopover.$emit('close');
      this.$refs.secondaryPopover.$emit('close');
      this.$refs.finishPopover.$emit('close');
    }
  }
};
</script>

<style scoped>

.pattern-wrap {
  outline: 1px solid black;
  width: 160px;
  height: 160px;
  position: relative;
}

.base-color {
  width: 100%;
  height: 19%;
  background-color: #ffffff;
}
.secondary-color {
  width: 160px;
  height: 19%;
  background-color: #cccccc;
}

.finish-color {
  height: 4px;
  width: 160px;
  background: black;
}
</style>
